/**
 * AVV-Abschnitt „Support-Zugriffe“ — die EINE Textquelle fuer die Karte unter
 * Einstellungen → Datenschutz, das PDF-Druckfenster und das Admin-Onboarding.
 * Verbindlich ist docs/ENTWURF-AVV-SUPPORT-ZUGRIFF.md (juristisch geprueft); Text nur dort aendern
 * und hier wortgleich nachziehen.
 */
export const AVV_TITEL = "Support-Zugriffe auf Ihr MAESTRO-Konto";
// Vertragsdatum als fester Text, kein eingesetzter Wert (Ratsche recherche-stand R1.6 B4).
export const AVV_UNTERTITEL = "Teil des Auftragsverarbeitungsvertrags (AVV) · Stand 09.10.2026";

export const AVV_ABSAETZE: readonly { stichwort: string; text: string }[] = [
  {
    stichwort: "Worum es geht.",
    text: "Wenn Sie Hilfe brauchen, etwa bei einem Fehler, kann sich unser Support vorübergehend in Ihr Konto einloggen und sich die Sache direkt ansehen.",
  },
  {
    stichwort: "Nur mit Ihrer Freigabe.",
    text: "Wir starten einen Support-Zugriff nur, wenn Sie als Inhaber oder eine von Ihnen benannte Person ihn vorher freigegeben haben, zum Beispiel per E-Mail oder am Telefon. Ihre Freigabe ist Ihre Weisung an uns. Wir vermerken sie in der Begründung des Zugriffs und nutzen den Zugriff nur für das Anliegen, für das Sie ihn freigegeben haben. Wichtig zu wissen: Die App fragt Sie dabei nicht selbst um Erlaubnis. Technisch kann unser Support den Zugriff ohne Ihre Mitwirkung starten. Dass wir das nur mit Ihrer Freigabe tun, ist unsere Zusage aus diesem Vertrag.",
  },
  {
    stichwort: "Wer zugreift.",
    text: "Nur Personen, die wir ausdrücklich als Plattform-Administratoren freigeschaltet und zur Vertraulichkeit verpflichtet haben. Würden wir dafür einmal externe Dienstleister einsetzen, wären sie Unterauftragsverarbeiter und stünden in unserer Liste der Unterauftragsverarbeiter.",
  },
  {
    stichwort: "Was der Support dabei kann.",
    text: "Während des Zugriffs hat der Support dieselben Rechte wie ein Inhaber Ihres Kontos. Er kann alle Daten in Ihrem Konto sehen und ändern, auch die Ihrer Gäste, und alles auslösen, was Sie selbst auslösen können. In Ihrer Teamliste erscheint dabei vorübergehend ein Eintrag „Support (MAESTRO)“. So erkennen Sie, dass gerade ein Zugriff läuft.",
  },
  {
    stichwort: "Wie lange.",
    text: "Jeder Zugriff ist befristet: normalerweise auf 30 Minuten, höchstens auf 120 Minuten. Eine Verlängerung gibt es nicht. Braucht der Support länger, muss er einen neuen Zugriff mit neuer Begründung anlegen. Nach Fristende entfernen wir den Zugang automatisch, in der Regel innerhalb einer Stunde. Der Support kann den Zugriff auch früher selbst beenden.",
  },
  {
    stichwort: "Was protokolliert wird.",
    text: "Für jeden Zugriff halten wir fest, wer ihn gestartet hat, mit welcher Begründung, wann er begonnen hat, bis wann er gelten sollte und wann er beendet wurde. Einzelne Klicks oder Änderungen während des Zugriffs stehen nicht in diesem Protokoll.",
  },
  {
    stichwort: "Wie lange das Protokoll bleibt.",
    text: "Solange Ihr Konto besteht. Wird Ihr Konto gelöscht, löschen wir die Protokolleinträge zu Ihrem Konto mit. Einträge, die aus Nachweisgründen übrig bleiben, lassen sich Ihrem Konto nicht mehr zuordnen. Persönliche Angaben und Begründungen darin schwärzen wir spätestens nach zwei Jahren.",
  },
  {
    stichwort: "Keine automatische Nachricht.",
    text: "Sie erhalten beim Start eines Support-Zugriffs keine automatische E-Mail oder sonstige Benachrichtigung. Wenn Sie wissen möchten, wann, durch wen und warum auf Ihr Konto zugegriffen wurde, fragen Sie uns. Wir geben Ihnen Auskunft aus dem Protokoll.",
  },
];

const esc = (s: string) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/** Druckfertiges HTML mit dem eingesetzten Betriebsnamen. */
export function avvDruckHtml(betrieb: string): string {
  const absaetze = AVV_ABSAETZE.map((a) => `<p><strong>${esc(a.stichwort)}</strong> ${esc(a.text)}</p>`).join("");
  return `<!doctype html><html lang="de"><head><meta charset="utf-8"><title>AVV – ${esc(AVV_TITEL)}</title>
<style>body{font:14px/1.6 system-ui,sans-serif;color:#222;max-width:680px;margin:32px auto;padding:0 16px}
h1{font-size:20px;margin:0 0 4px}.meta{color:#555;margin:0 0 20px}p{margin:0 0 12px}</style></head><body>
<p class="meta">Auftragsverarbeitungsvertrag (AVV) · Betrieb: ${esc(betrieb)}</p>
<h1>${esc(AVV_TITEL)}</h1><p class="meta">${esc(AVV_UNTERTITEL)}</p>${absaetze}</body></html>`;
}

// ponytail: Druckdialog statt PDF-Bibliothek (wie der Angebots-Druck in offer-public.tsx);
// „Als PDF sichern" bietet jeder Browser. Eigene PDF-Erzeugung erst, wenn ein fertiges Dateiattachment noetig ist.
export function avvAlsPdfDrucken(betrieb: string): boolean {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.open();
  w.document.write(avvDruckHtml(betrieb));
  w.document.close();
  w.focus();
  w.print();
  return true;
}
